import { baseApi } from './baseApi';

export const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (params) => ({
        url: '/products',
        params,
      }),
      providesTags: ['Product'],
    }),
    getProductsByCategoryTree: builder.query({
      query: () => '/products/category-tree',
      providesTags: ['Product'],
    }),
    getProduct: builder.query({
      query: (id) => `/products/${id}`,
      providesTags: (result, error, id) => [{ type: 'Product', id }],
    }),
    createProduct: builder.mutation({
      query: (data) => ({
        url: '/products',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    updateProduct: builder.mutation({
      query: (arg) => {
        const { id, body, ...data } = arg;
        return {
          url: `/products/${id}`,
          method: 'PUT',
          body: body !== undefined ? body : data,
        };
      },
      invalidatesTags: (result, error, arg) => [{ type: 'Product', id: arg?.id }],
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/products/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Product'],
    }),
    getCategories: builder.query({
      query: (params) => {
        let tree = false;
        let search = '';
        if (typeof params === 'boolean') {
          tree = params;
        } else if (params) {
          tree = params.tree || false;
          search = params.search || '';
        }
        return {
          url: '/product-categories',
          params: {
            ...(tree ? { tree: true } : {}),
            ...(search ? { search } : {}),
          },
        };
      },
      providesTags: ['Product'],
    }),
    getCategory: builder.query({
      query: (id) => `/product-categories/${id}`,
      providesTags: (result, error, id) => [{ type: 'Product', id }],
    }),
    createCategory: builder.mutation({
      query: (data) => ({
        url: '/product-categories',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    updateCategory: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/product-categories/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Product'],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/product-categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Product'],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useGetProductsByCategoryTreeQuery,
  useGetProductQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetCategoriesQuery,
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = productsApi;
